webpackJsonp([119559695529715],{

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(67);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(65);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _NetlifyForm = __webpack_require__(68);
	
	var _NetlifyForm2 = _interopRequireDefault(_NetlifyForm);
	
	var _FooterCC = __webpack_require__(78);
	
	var _FooterCC2 = _interopRequireDefault(_FooterCC);
	
	var _HeaderCC = __webpack_require__(91);
	
	var _HeaderCC2 = _interopRequireDefault(_HeaderCC);
	
	var _reactIframe = __webpack_require__(66);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	var _Split = __webpack_require__(44);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _App = __webpack_require__(36);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Sidebar = __webpack_require__(59);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _LoginForm = __webpack_require__(55);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _Article = __webpack_require__(37);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Section = __webpack_require__(42);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Heading = __webpack_require__(16);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Paragraph = __webpack_require__(24);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Grommet = __webpack_require__(63);
	
	var _Grommet2 = _interopRequireDefault(_Grommet);
	
	var _Header = __webpack_require__(53);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Title = __webpack_require__(61);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Menu = __webpack_require__(41);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Anchor = __webpack_require__(27);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _Box = __webpack_require__(8);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Quote = __webpack_require__(57);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _Card = __webpack_require__(51);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Columns = __webpack_require__(52);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Image = __webpack_require__(40);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Headline = __webpack_require__(39);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SocialFacebook = __webpack_require__(45);
	
	var _SocialFacebook2 = _interopRequireDefault(_SocialFacebook);
	
	var _LinkNext = __webpack_require__(28);
	
	var _LinkNext2 = _interopRequireDefault(_LinkNext);
	
	var _Hero = __webpack_require__(54);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Form = __webpack_require__(30);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _TextInput = __webpack_require__(60);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _NumberInput = __webpack_require__(56);
	
	var _NumberInput2 = _interopRequireDefault(_NumberInput);
	
	var _SVGIcon = __webpack_require__(58);
	
	var _SVGIcon2 = _interopRequireDefault(_SVGIcon);
	
	var _Toast = __webpack_require__(62);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _SocialShare = __webpack_require__(43);
	
	var _SocialShare2 = _interopRequireDefault(_SocialShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Customers = function (_React$PureComponent) {
	  _inherits(Customers, _React$PureComponent);
	
	  function Customers() {
	    _classCallCheck(this, Customers);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Customers.prototype.render = function render() {
	    return _react2.default.createElement(
	      _App2.default,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Customers - Clean Clothes'
	        )
	      ),
	      _react2.default.createElement(_HeaderCC2.default, null),
	      _react2.default.createElement(
	        _Hero2.default,
	        { background: _react2.default.createElement(_Image2.default, { src: '/backpack.jpg',
	            fit: 'cover',
	            full: true }),
	          backgroundColorIndex: 'dark' },
	        _react2.default.createElement(
	          _Box2.default,
	          { direction: 'row',
	            justify: 'center',
	            align: 'center' },
	          _react2.default.createElement(_Box2.default, { basis: '1/2',
	            align: 'end',
	            pad: 'medium' }),
	          _react2.default.createElement(
	            _Box2.default,
	            { basis: '1/2',
	              align: 'start',
	              pad: 'medium' },
	            _react2.default.createElement(
	              _Box2.default,
	              { colorIndex: 'grey-2-a' },
	              _react2.default.createElement(_Card2.default, { heading: 'Customers',
	                description: 'The Impact' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { pad: 'large' },
	        _react2.default.createElement(
	          _Box2.default,
	          { direction: 'row', separator: 'top', pad: { vertical: 'large' } },
	          _react2.default.createElement(_Card2.default, {
	            heading: 'Cheri' }),
	          _react2.default.createElement(
	            _Box2.default,
	            { textAlign: 'left' },
	            _react2.default.createElement(
	              _Paragraph2.default,
	              { size: 'large' },
	              'I truly thank Clean Clothes for their outstanding and liberating selfless service that they have provided through Jesus Christ. They have helped me in friendship, companionship and to have clean clothes.'
	            ),
	            _react2.default.createElement(
	              _Paragraph2.default,
	              { size: 'large' },
	              'Being homeless is very tiresome and requires a lot of work. However, alot of people throw the clothes away once they are worn. In turn this is not good for our environment or community. Clean Clothes has help reduce waste and has allowed us to keep reusing the clothes we enjoy.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Box2.default,
	          { direction: 'row', separator: 'top', pad: { vertical: 'large' } },
	          _react2.default.createElement(_Card2.default, {
	            heading: 'Bret' }),
	          _react2.default.createElement(
	            _Box2.default,
	            { textAlign: 'left' },
	            _react2.default.createElement(
	              _Paragraph2.default,
	              { size: 'large' },
	              'I can tell you it is really really inconvenient and unfortunate to not have clean clothes. And it\'s also really uncool to have a pair of jeans, get them filthy, throw them out, and get a new pair of jeans. Hence, the fabulousness of the Dutch Girl and your and all your volunteers\' service. I really do thank you.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_FooterCC2.default, null)
	    );
	  };
	
	  return Customers;
	}(_react2.default.PureComponent);
	
	exports.default = Customers;
	module.exports = exports['default'];

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Customers = __webpack_require__(275);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Customers).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Customers = __webpack_require__(276);
	
	var _Customers2 = _interopRequireDefault(_Customers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Customers2.default, null)
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-customers-js-78428b4c58429e2f2a81.js